import { defineMessages } from 'react-intl-next';

const messages: {
	buttonLoginToConfluenceNewTab: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectConfluenceButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectConfluenceButtonAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectLoomToConfluenceImageAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectToConfluenceDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectToConfluenceHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linkAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linkTroubleshootingText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loginAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loginButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loginText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loginToConfluenceIconAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paragraphAlreadyLoggedIn: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paragraphLogin: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	paragraphStillHavingTrouble: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	refreshBanner: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	refreshBannerLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	connectToConfluenceHeading: {
		id: 'embedded.confluence.connect-to-confluence.heading',
		description: 'The heading for the connect to Confluence page',
		defaultMessage: 'Connect to Confluence',
	},
	connectToConfluenceDescription: {
		id: 'embedded.confluence.connect-to-confluence.description',
		description: 'The description for the connect to Confluence page',
		defaultMessage: 'Save ideas, track agenda items, and take notes together as a team.',
	},
	connectConfluenceButton: {
		id: 'embedded.confluence.connect-to-confluence.button',
		description: 'The text inside the connect to Confluence button',
		defaultMessage: 'Connect Confluence',
	},
	connectLoomToConfluenceImageAriaLabel: {
		id: 'embedded.confluence.connect-loom-to-confluence.image.aria-label',
		description: 'The aria label for the Connect Loom to Confluence image',
		defaultMessage: 'Connect Loom to Confluence',
	},
	loginToConfluenceIconAriaLabel: {
		id: 'embedded.confluence.login-to-confluence.icon.aria-label',
		description: 'The aria label for the Login to Confluence icon',
		defaultMessage: 'Login to Confluence',
	},
	connectConfluenceButtonAriaLabel: {
		id: 'embedded.confluence.connect-to-confluence.button.aria-label',
		description: 'The aria label for the connect to Confluence button',
		defaultMessage: 'Connect Confluence Button',
	},
	buttonLoginToConfluenceNewTab: {
		id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
		description: 'The text inside the login to Confluence button',
		defaultMessage: 'Log in to Confluence',
	},
	paragraphLogin: {
		id: 'embedded.confluence.need-to-log-in-paragraph',
		description:
			'The text inside embedded confluence that tell user they need to be logged in to view this page',
		defaultMessage: 'You need to be logged in to view this page',
	},
	paragraphAlreadyLoggedIn: {
		id: 'embedded.confluence.already-logged-in-paragraph',
		description:
			'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
		defaultMessage: 'Already logged in? Try refreshing.',
	},
	paragraphStillHavingTrouble: {
		id: 'embedded.confluence.still-having-trouble-paragraph',
		description:
			'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
		defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
	},
	linkTroubleshootingText: {
		id: 'embedded.confluence.troubleshooting-link-text',
		description:
			'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
		defaultMessage: 'refer to this troubleshooting guide.',
	},
	linkAriaLabel: {
		id: 'embedded.confluence.troubleshooting-link.aria-label',
		description: 'The aria label for troubleshooting link.',
		defaultMessage: 'troubleshooting guide link',
	},
	loginAriaLabel: {
		id: 'embedded.confluence.login-page.login-button.aria-label',
		description: 'The aria label for login button',
		defaultMessage: 'Login Button',
	},
	loginText: {
		id: 'embedded.confluence.login-page.login-text',
		description: 'Text to display before login button',
		defaultMessage: 'You need to be logged in to view this page',
	},
	loginButton: {
		id: 'embedded.confluence.login-page.login-button',
		description: 'The label for login button',
		defaultMessage: 'Log in to Confluence',
	},
	refreshBanner: {
		id: 'embedded.confluence.login-page.refresh-page-banner',
		description: 'The banner displayed prompting a user to refresh the page',
		defaultMessage:
			'After logging in, this page should refresh automatically. If not, you can click here to refresh',
	},
	refreshBannerLink: {
		id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
		description: 'A link to refresh the page',
		defaultMessage: 'Refresh page',
	},
});

export default messages;
